module.exports = __webpack_public_path__ + "static/img/4344_phase_function_Paper_Points.ebcb157.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4344_phase_function_Paper_Points.png
// module id = dOsD
// module chunks = 0